import { render, staticRenderFns } from "./Vilage.old.vue?vue&type=template&id=2d9a74ac"
import script from "./Vilage.old.vue?vue&type=script&lang=js"
export * from "./Vilage.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports